import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 18v-12h-5v10a2 2 0 0 1 -2 2","key":"svg-0"}],["path",{"d":"M14 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4","key":"svg-1"}]]

/**
 * IconCurrencySom
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktc29tIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMCAxOHYtMTJoLTV2MTBhMiAyIDAgMCAxIC0yIDIiIC8+CiAgPHBhdGggZD0iTTE0IDZ2MTJoNGEzIDMgMCAwIDAgMCAtNmgtNGg0YTMgMyAwIDAgMCAwIC02aC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-som
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencySom = createReactComponent('outline', 'currency-som', 'CurrencySom', __iconNode);

export default IconCurrencySom;